import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DemoListComponent} from './demo-list/demo-list.component';
import {DemoAuditComponent} from './demo-audit/demo-audit.component';

const demoRoutes: Routes = [
  {
    path: 'demo', component: DemoListComponent
  },
  {
    path: 'demo/:guid', component: DemoAuditComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(demoRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class DemoRoutingModule {}
